import $           from "jquery";
import pageScripts from "./pages";

require( "../../../superunie-topmerken/assets/scripts/main" );

$( document ).ready( function () {
	//Require all components here.
	require( "./components/product-block" );
	require( "./components/content-block-video" );
	require( "./components/primoro-slider" );

	document.body.className.replace( /-/g, "_" ).split( /\s+/ ).forEach( cls => {
		pageScripts[ cls ] && pageScripts[ cls ]();
	} );
} );
